import { useMutation, useQuery } from '@tanstack/react-query';

import { addFieldIdToForm, Field } from '@components/form/dynamic-fields';

import { createFieldNameToFieldIdMap, remapConditionProperties } from 'utils/prepare-form';

import { request } from './request';

export type ApplicationData = {
  name: string;
  ssn: string | null;
};

export type FormResponse = {
  application: ApplicationData;
  completed: boolean;
  form: Field[];
};

export const useForm = (id: string) => {
  return useQuery({
    queryKey: ['form', id],
    staleTime: Infinity,
    queryFn: async () => {
      const response = await request.get<FormResponse>(`integrations/rookie/${id}`);
      // Make sure all fields have unique IDs
      const formWithIds = addFieldIdToForm(response.data.form);

      // Next we need to re-map field condition `name`s to their corresponding unique IDs
      const nameIdMap = createFieldNameToFieldIdMap(formWithIds);
      const remapped = remapConditionProperties(formWithIds, nameIdMap);

      return {
        ...response.data,
        form: remapped,
      } as FormResponse;
    },
  });
};

export const useSaveForm = (id: string) => {
  return useMutation({
    mutationFn: (formData: FormData) => {
      return request.patch<FormData>(`integrations/rookie/${id}`, formData);
    },
  });
};
